import { ApiClient } from './api-client';

export function fetchUserPreferences(userId) {
  return ApiClient.getInstance()
    .get('/user/:id/preferences', { urlParams: { id: userId } })
    .then((res) => res.data)
    .catch((error) => {
      console.error('Error fetching user preferences:', error);
      throw error;
    });
}
  

export function saveUserPreferences(userId, prefs) {
  return ApiClient.getInstance()
    .post('/user/:id/preferences', prefs, { urlParams: { id: userId } })
    .catch((error) => {
      console.error('Error saving user preferences:', error);
      throw error;
    });
}
